import { useState, useEffect } from "react";
import BLock_edit_contaoner from "./redux-container/BLock_edit_container";
import Block_elementor_container from "./redux-container/Block_elementor_container";
import Editor_container from "./redux-container/editor_container";
import Setting_panel_container from "./redux-container/setting_panel_container";
import Wb_layout_container from "./redux-container/wb_layout_container";
import { __ } from '@wordpress/i18n';
import { check_active_plugins, install_activate_plugin } from "../helper/helper-function";

const Widget_builder = (props) => {

  const plugin_detail = [
    {
      'name': 'elementor',
      'label': 'elementor',
      'plugin_slug': 'elementor/elementor.php',
      'type': 'plugin',
      'freepro': '0',
      'text': __('Oops! Elementor Page Builder is not activated. Please install it now to unlock full functionality.', 'wdesignkit'),
      'class': 'wkit-elementor-bg',
      'color': '#91003B',
    },
    {
      'name': 'the-plus-addons-for-block-editor',
      'label': 'gutenberg',
      'plugin_slug': 'the-plus-addons-for-block-editor/the-plus-addons-for-block-editor.php',
      'type': 'plugin',
      'freepro': '0',
      'text': __('Oops! Nexter blocks is not activated. Please install it now to unlock full functionality.', 'wdesignkit'),
      'class': 'wkit-nexter-bg',
      'color': '#162D9E',
    },
    {
      'name': 'bricks',
      'label': 'bricks',
      'plugin_slug': 'bricks/bricks.php',
      'type': 'theme',
      'freepro': '1',
      'text': __('Oops! Bricks Theme is not activated. Please install it now to unlock full functionality.', 'wdesignkit'),
      'link': 'https://academy.bricksbuilder.io/article/installation-activation/',
      'class': 'wkit-bricks-bg',
      'color': '#000000',
    },
  ],

    current_index = plugin_detail.findIndex(data => data.label === props.widgetdata.type);

  const [active, setactive] = useState("layout");
  const [plugin_status, setPlugin_status] = useState([]);
  const [openYtPopUp, setOpenYtPopUp] = useState(false);

  useEffect(() => {
    loadStylesheet('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css');
    check_active_plugins([plugin_detail[current_index]]).then((response) => {
      if (response?.data?.plugins) {
        let plugin_data = {},
          indx = response.data.plugins.findIndex((plugin) => plugin.name == 'bricks');
        if ((indx > -1) && (response.data.plugins?.[indx]?.status == 'active')) {
          loadStylesheet(wdkitData.WDKIT_SITE_URL + '/wp-content/themes/bricks/assets/css/libs/themify-icons.min.css');
        }

        response.data.plugins.map((plugin) => {
          plugin_data[plugin.name] = plugin.status;
        });
        setPlugin_status(plugin_data);
      }
    })
  }, [])

  useEffect(() => {
    if (!document.body.classList.contains('folded')) {
      document.body.classList.add("folded");
    }
  });

  const loadStylesheet = (href) => {
    if (!document.querySelector(`link[href="${href}"]`)) {
      let link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href + "?v=" + new Date().getTime(); // Avoid caching issues
      document.head.appendChild(link);
    }
  }

  var type_class = '',
    x = 0,
    w = 0;

  if (props && props.widgetdata && props.widgetdata.type && props.widgetdata.type == 'elementor') {
    type_class = 'wkit-elementor-builder';
  } else if (props && props.widgetdata && props.widgetdata.type && props.widgetdata.type == 'gutenberg') {
    type_class = 'wkit-gutenberg-builder';
  } else if (props && props.widgetdata && props.widgetdata.type && props.widgetdata.type == 'bricks') {
    type_class = 'wkit-bricks-builder';
  }

  const Drag_start = (e) => {
    x = e.clientX;
    const styles = window.getComputedStyle(e.target.parentElement);
    w = parseInt(styles.width, 10);
  }

  const Drag_over = (e) => {
    const dx = e.clientX - x;
    let final_width = `${w + dx}px`;
    e.target.parentElement.style.width = final_width;


    if (document.querySelector('.wkit-wb-third.content.wkit-wb-hide')) {
      document.querySelector('.wkit-wb-second.content').style.width = `calc((100% - ${final_width})) `;
    } else {
      document.querySelector('.wkit-wb-second.content').style.width = `calc((100% - ${final_width})/2) `;
      document.querySelector('.wkit-wb-third.content').style.width = `calc((100% - ${final_width})/2) `;
    }
  }

  const Outside_click = (e) => {
    let drop_down = document.querySelectorAll(".wkit-wb-custom-dropDown-content.wkit-wb-show")
    let custom_icon_popup = document.querySelectorAll(".wkit-wb-choose-popup.wkit-wb-flex-show")
    if (!e.target.closest(".wkit-wb-custom-dropDown-header") && drop_down) {
      drop_down.forEach((content) => {
        content.classList.remove("wkit-wb-show");
      })
    }

    if (!e.target.closest(".wkit-wb-choose-popup.wkit-wb-flex-show") && !e.target.closest(".wb-options-inp.wkit-wb-icon-select") && custom_icon_popup) {
      custom_icon_popup.forEach((content) => {
        content.classList.remove("wkit-wb-flex-show");
      })
    }
  }

  const Close_popup = (e) => {
    if (Object.values(e?.target?.classList).includes('wkit-wb-yt-popup')) {
      setOpenYtPopUp(false);
    }
  }

  const Install_plugin = async (p_data) => {

    let update_status = { ...plugin_status, [p_data.name]: 'loading' }
    setPlugin_status(update_status);

    let obj = {
      freepro: p_data.freepro,
      original_slug: p_data.name,
      plugin_slug: p_data.plugin_slug,
      status: "inactive",
      type: p_data.type,
    }

    install_activate_plugin(obj).then(res => {
      if (res.data.success) {
        update_status = { ...plugin_status, [res.data.slug]: res.data.status }
        setPlugin_status(update_status);

        if (p_data.name == 'elementor') {
          loadStylesheet(wdkitData.WDKIT_SITE_URL + '/wp-content/plugins/elementor/assets/lib/eicons/css/elementor-icons.css');
        }
      } else {
        props.wdkit_set_toast(['Installation Failed!', 'Plugin is not installed', '', 'danger']);
      }
    })
  }

  const Install_btn = () => {

    if (plugin_detail[current_index]?.link) {
      return (
        <a href={plugin_detail[current_index]?.link} className='wkit-redirect-link ' target='_blank' rel="noopener noreferrer">
          {__('How to Install ?', 'wdesignkit')}
        </a>
      )
    } else if (plugin_status[plugin_detail[current_index].name] === 'loading') {
      return (
        <button className="wkit-install-plugin-btn">
          <span className="wkit-loader"></span>
        </button>
      )
    }

    return (
      <button className="wkit-install-plugin-btn" onClick={() => { Install_plugin(plugin_detail[current_index]) }}>{__('Install Now', 'wdesignkit')}</button>
    )
  }

  return (
    <>
      <div className={`wkit-wb-main-builder-page ${type_class}`} onClick={(e) => { Outside_click(e); }}>
        {(plugin_status && Object.keys(plugin_status)?.length > 0 && plugin_status?.[plugin_detail?.[current_index]?.name] !== 'active') &&
          <div className={`wkit-install-dependency wkit-wb-notice ${plugin_detail[current_index]?.class}`}>
            <div className='wkit-wb-notice-content'>
              <svg xmlns="http://www.w3.org/2000/svg" className="wkit-notice-svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                <path d="M7.75548 1.47626L0.768852 13.5766C0.642649 13.7951 0.576195 14.043 0.576172 14.2953C0.576149 14.5477 0.642556 14.7956 0.768719 15.0141C0.894882 15.2326 1.07635 15.4141 1.29489 15.5403C1.51343 15.6664 1.76132 15.7328 2.01366 15.7328H15.9858C16.2381 15.7328 16.486 15.6664 16.7046 15.5403C16.9231 15.4141 17.1046 15.2326 17.2307 15.0141C17.3569 14.7956 17.4233 14.5477 17.4233 14.2953C17.4233 14.043 17.3568 13.7951 17.2306 13.5766L10.2447 1.47626C10.1186 1.25778 9.93716 1.07636 9.71868 0.950229C9.50021 0.824095 9.25238 0.75769 9.0001 0.75769C8.74783 0.75769 8.5 0.824095 8.28152 0.950229C8.06304 1.07636 7.88162 1.25778 7.75548 1.47626Z" fill={plugin_detail[current_index]?.color} />
                <path d="M9.09088 5.20837H8.90863C8.45993 5.20837 8.09619 5.57211 8.09619 6.02081V9.90412C8.09619 10.3528 8.45993 10.7166 8.90863 10.7166H9.09088C9.53958 10.7166 9.90332 10.3528 9.90332 9.90412V6.02081C9.90332 5.57211 9.53958 5.20837 9.09088 5.20837Z" fill="#FFF7ED" />
                <path d="M8.99975 13.7964C9.49878 13.7964 9.90332 13.3918 9.90332 12.8928C9.90332 12.3938 9.49878 11.9893 8.99975 11.9893C8.50073 11.9893 8.09619 12.3938 8.09619 12.8928C8.09619 13.3918 8.50073 13.7964 8.99975 13.7964Z" fill="#FFF7ED" />
              </svg>
              <span className="wkit-install-plugin-text">{plugin_detail[current_index]?.text}</span>
            </div>
            {Install_btn('convert')}
          </div>
        }
        <Setting_panel_container
          plugin_status={plugin_status}
          plugin_detail={plugin_detail}
        />
        <div className={`wkit-wb-widget-builder ${Object.keys(plugin_status).length > 0 && plugin_status[plugin_detail[current_index].name] !== 'active' ? 'wkit-wb-rm-height' : ''}`}>
          <div className="wkit-wb-first-part content">
            <div className="wkit-wb-first-part-content">
              <Editor_container plugin_status={plugin_status} />
            </div>
            <div className="wkit-wb-first-second-drag"
              draggable
              onDragStart={(e) => { Drag_start(e) }}
              onDrag={(e) => { Drag_over(e) }}
              onDragEnd={(e) => { Drag_over(e) }}></div>
          </div>
          <div className="wkit-wb-second content">
            <div className="wb-second-header">
              <div className={active == "layout" ? "wb-second-header-layout active" : "wb-second-header-layout"} onClick={() => setactive("layout")} >
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 6H14.5M6.5 14V6M3.83333 2H13.1667C13.903 2 14.5 2.59695 14.5 3.33333V12.6667C14.5 13.403 13.903 14 13.1667 14H3.83333C3.09695 14 2.5 13.403 2.5 12.6667V3.33333C2.5 2.59695 3.09695 2 3.83333 2Z" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

                <span className="wb-layout-text">{__('Layout', 'wdesignkit')}</span>
              </div>
              <div className={active == "style" ? "wb-second-header-style active" : "wb-second-header-style"} onClick={() => setactive("style")} >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3337 6.66732V2.40065C13.3337 2.02728 13.3337 1.8406 13.261 1.69799C13.1971 1.57255 13.0951 1.47056 12.9697 1.40664C12.8271 1.33398 12.6404 1.33398 12.267 1.33398H3.73366C3.36029 1.33398 3.17361 1.33398 3.031 1.40664C2.90556 1.47056 2.80357 1.57255 2.73965 1.69799C2.66699 1.8406 2.66699 2.02728 2.66699 2.40065V6.66732M13.3337 6.66732H2.66699M13.3337 6.66732V6.80065C13.3337 7.92078 13.3337 8.48078 13.1157 8.90865C12.9239 9.28498 12.618 9.59092 12.2417 9.78265C11.8138 10.0007 11.2538 10.0007 10.1337 10.0007H5.86699C4.74689 10.0007 4.18683 10.0007 3.75901 9.78265C3.38269 9.59092 3.07673 9.28498 2.88498 8.90865C2.66699 8.48078 2.66699 7.92078 2.66699 6.80065V6.66732M9.66699 10.0007V13.0007C9.66699 13.9211 8.92079 14.6673 8.00033 14.6673C7.07986 14.6673 6.33366 13.9211 6.33366 13.0007V10.0007" strokeOpacity="0.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

                <span className="wb-style-text">{__('Style', 'wdesignkit')}</span>
              </div>
            </div>
            {active == "layout" &&
              < Wb_layout_container array_type={"layout"} />
            }
            {active == "style" &&
              < Wb_layout_container array_type={"style"} />
            }
          </div>
          <div className="wkit-wb-third content">
            <div className="wkit-wb-third-header">
              <div className={(props && !props.controller || !props.controller.controller) || (props && props.controller.controller?.controller_type) ? "wkit-wb-third-header-text activate" : "wkit-wb-third-header-text"} onClick={(e) => { props.addToActiveController(""); }} >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.6106 9.44683V11.6135M11.6106 11.6135V13.7802M11.6106 11.6135H13.7772M11.6106 11.6135H9.4439M6.55501 9.92831V13.2987C6.55501 13.5646 6.33945 13.7802 6.07353 13.7802H2.70316C2.43725 13.7802 2.22168 13.5646 2.22168 13.2987V9.92831C2.22168 9.6624 2.43725 9.44683 2.70316 9.44683H6.07353C6.33945 9.44683 6.55501 9.6624 6.55501 9.92831ZM6.55501 2.70609V6.07646C6.55501 6.34238 6.33945 6.55794 6.07353 6.55794H2.70316C2.43725 6.55794 2.22168 6.34238 2.22168 6.07646V2.70609C2.22168 2.44018 2.43725 2.22461 2.70316 2.22461H6.07353C6.33945 2.22461 6.55501 2.44018 6.55501 2.70609ZM13.7772 2.70609V6.07646C13.7772 6.34238 13.5617 6.55794 13.2958 6.55794H9.92538C9.65947 6.55794 9.4439 6.34238 9.4439 6.07646V2.70609C9.4439 2.44018 9.65947 2.22461 9.92538 2.22461H13.2958C13.5617 2.22461 13.7772 2.44018 13.7772 2.70609Z" strokeLinecap="round" />
                </svg>
                <span>{__('Controls', 'wdesignkit')}</span>
              </div>
              <div className={(props && props.controller && props.controller.controller && !props.controller.controller?.controller_type) ? "wkit-wb-third-header-text activate" : "wkit-wb-third-header-text-edit"} >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.38444 2.20095H3.05527C2.72722 2.20095 2.41261 2.33127 2.18064 2.56323C1.94868 2.7952 1.81836 3.10981 1.81836 3.43786V12.0962C1.81836 12.4243 1.94868 12.7389 2.18064 12.9708C2.41261 13.2028 2.72722 13.3331 3.05527 13.3331H11.7136C12.0417 13.3331 12.3563 13.2028 12.5882 12.9708C12.8202 12.7389 12.9505 12.4243 12.9505 12.0962V7.76703M12.0228 1.27293C12.2689 1.02689 12.6026 0.888672 12.9505 0.888672C13.2985 0.888672 13.6322 1.02689 13.8782 1.27293C14.1242 1.51897 14.2625 1.85266 14.2625 2.20061C14.2625 2.54856 14.1242 2.88225 13.8782 3.12829L8.00289 9.0036L5.52908 9.62205L6.14753 7.14824L12.0228 1.27293Z" strokeOpacity="0.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

                <span>{__('Edit', 'wdesignkit')}</span>
              </div>
            </div>

            {props && props.controller && props.controller.controller && !props.controller.controller?.controller_type &&
              <BLock_edit_contaoner />
            }

            <div style={{ display: props && !props.controller || !props.controller.controller || props.controller.controller?.controller_type ? "block" : "none", height: '100%' }} >
              <Block_elementor_container
                array_type={active} />
            </div>

            {(props && (!props.controller || !props.controller.controller || props.controller.controller?.controller_type)) && !(wdkitData?.wdkit_white_label?.plugin_news) &&
              <div className='wkit-wb-yt-link' onClick={() => setOpenYtPopUp(true)}>
                <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.0924 2.04688H2.90762C1.30178 2.04688 0 3.34866 0 4.9545V9.04601C0 10.6518 1.30178 11.9536 2.90762 11.9536H11.0924C12.6982 11.9536 14 10.6518 14 9.04601V4.9545C14 3.34866 12.6982 2.04688 11.0924 2.04688ZM9.12598 7.19932L5.2977 9.02518C5.19569 9.07383 5.07786 8.99945 5.07786 8.88645V5.12061C5.07786 5.006 5.19879 4.93172 5.30101 4.98353L9.12929 6.92351C9.24311 6.98118 9.24113 7.14441 9.12598 7.19932Z" fill="#fff" />
                </svg>
                <span className="wkit-wb-yt-link-text">{__('Watch our YouTube video')}</span>
              </div>
            }

            {openYtPopUp &&
              <div id="wkit-yt-popup-open" className="wkit-yt-overlay" onClick={(e) => { Close_popup(e) }}>
                <div className="wkit-wb-yt-popup">
                  <div className="wkit-yt-carousel-slide">
                    <iframe className="wkit-wb-yt-carousel-img" src="https://www.youtube.com/embed/videoseries?list=PLFRO-irWzXaJUu7MKQ8Gv63ATyZENEAPG&showinfo=1&autoplay=1&rel=0" allowFullScreen></iframe>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

      </div>
    </>
  );
}

export default Widget_builder;